import HolrDetailsModal from './HolrDetailsModal';

export default HolrDetailsModal;
